{
  "longPressMessage": "Tryk og hold nede for at åbne forhåndsvisningen"
}
